import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import meta from './meta.ts';

export const SUPPORTED_LANGUAGES = ['en', 'uk', 'de'];
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: (lng: string, ns: string) => {
        const path: string = (meta?.localesMap as Record<SupportedLanguage, Record<string, string>>)?.[
          lng as SupportedLanguage
        ]?.[ns] as string;
        return path && typeof window !== 'undefined' && window.location.hostname !== 'localhost'
          ? `/locales${path}`
          : `/locales/${lng}/${ns}.json`;
      },
      crossDomain: true,
      allowMultiLoading: false,
    },
    fallbackLng: 'en',
    debug: false,
    supportedLngs: SUPPORTED_LANGUAGES,
    load: 'languageOnly',
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
